export default __webpack_public_path__ + "89fe70fbc397441d0b1f8e5a7e2e808a.svg";